import { NICmsContentComponent } from '@icms/core/content';
export namespace NPageEditorialFaq {
    export const QUESTIONS_LIMIT = 3;
    export interface IComponentData extends NICmsContentComponent.IData {
        header: string;
        headerSize?: string;
        backgroundColor?: string;
        columns: IPageEditorialColumns[];
        viewMore?: boolean;
        ctaLabel?: string;
        ctaLink?: string;
    }
    export interface IPageEditorialColumns extends IComponentData {
        variant?: EVariant;
        image?: string;
        headerSize?: string;
        questionSize?: string;
        answerSize?: string;
        questions: IPageComponentFaqDataTexts[];
        ctaLabel?: string;
        ctaLink?: string;
    }
    export interface IPageComponentFaqDataTexts extends NICmsContentComponent.IData {
        question: string;
        answer: string;
    }
    export enum EVariant {
        image = 'image',
        tabs = 'tabs'
    }
}
